import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import TaskPdfHeader from "./TaskPdfHeader";
import useTaskPdfHooks from "./TaskPdf.hooks";
import MasterDataSection from "../taskPane/masterDataSection/MasterDataSection";
import MentionInputRender from "../../common/components/mentionInput/MentionInputRender";
import { Box } from "@mui/material";
import { useTranslation } from "../../localization/useTranslation";
import SubTasks from "../subTasks/SubTasks";
import TaskDocumentation from "../taskPane/taskDocumentation/TaskDocumentation";
import TaskRelationsBox from "../taskPane/taskRelationsBox/TaskRelationsBox";
import TaskComments from "../taskPane/taskComments/TaskComments";
import DotLegalSection from "../../common/components/dotLegalSection/DotLegalSection.tsx";
import React from "react";
import EvaluationQuestionnaireContent from "../../common/components/questionnaireComponents/evaluateQuestionnaireDialog/evaluationQuestionnaireContent/EvaluationQuestionnaireContent.tsx";
import { EntityType } from "@common/Common.types.ts";
import { isNullOrWhitespace } from "@common/stringOperations.ts";

function TaskPdf() {
    const { task } = useTaskPdfHooks();
    const { translateString } = useTranslation();

    return (
        <Box sx={{ padding: 3 }}>
            {task && (
                <>
                    <TaskPdfHeader
                        activityName={task.name}
                        taskName={task.processingActivityName}
                        customTaskId={task.customId}
                        processingActivtiyId={task.processingActivityId}
                        annualWheelActivityId={task.annualWheelActivityId}
                        isAdHocTask={task.isAdHocTask}
                        riskMitigationPlanId={task.riskMitigationPlanId}
                    />
                    <Box sx={{ mt: 1 }} className="avoid-page-break">
                        <MasterDataSection
                            passIsDoneLoading={() => {}}
                            taskId={task.id}
                            masterData={
                                task
                                    ? {
                                          customId: task.customId,
                                          deadline: task.deadline,
                                          deadlineMaxDate: task.deadlineMaxDate,
                                          documentationRequired: task.documentationRequired,
                                          hasDocument: task.hasDocument,
                                          isOverdue: task.isOverdue,
                                          isAdHocTask: task.isAdHocTask,
                                          legalEntityName: task.legalEntityName,
                                          name: task.name,
                                          isProcessingActivityValidation: task.isProcessingActivityValidation,
                                          annualWheelActivityGeneralType: task.annualWheelActivityGeneralType,
                                          frameworks: [],
                                      }
                                    : undefined
                            }
                            isLoading={!task}
                            refetchTask={() => {}}
                            isPdf
                            isSingleColumn
                        />
                    </Box>

                    <Box sx={{ mt: 1 }} className="avoid-page-break">
                        <TaskRelationsBox canEdit={false} taskId={task.id} />
                    </Box>

                    {task.description && (
                        <Box sx={{ mt: 2 }}>
                            <DotLegalSection>
                                <DotLegalHeader marginTop={0} headerStyle="small">
                                    {translateString("description")}
                                </DotLegalHeader>
                                <Box sx={(theme) => ({ color: theme.palette.primary.dark, fontSize: theme.typography.pxToRem(14), whiteSpace: "pre-line" })}>
                                    <MentionInputRender value={task.description ?? ""} />
                                </Box>
                            </DotLegalSection>
                        </Box>
                    )}

                    <Box sx={{ mt: 1 }} className="avoid-page-break">
                        <SubTasks
                            passIsDoneLoading={() => {}}
                            disabled={false}
                            taskId={task.id}
                            updateTaskState={() => {}}
                            allDataIsDoneLoading
                            isAdHocTask={task.isAdHocTask}
                        />
                    </Box>
                    <Box sx={{ mt: 1 }} className="avoid-page-break">
                        <TaskDocumentation
                            passIsDoneLoading={() => {}}
                            disabled
                            taskId={task.id}
                            taskName={task.name}
                            updateTaskState={() => {}}
                            updateDocumentState={() => {}}
                            show
                            isDocumentationRequired={task?.documentationRequired}
                            onClose={() => {}}
                            allDataIsDoneLoading
                            isPdf
                        />
                    </Box>
                    {(task?.evaluation || task?.evaluationStatus) && (
                        <Box sx={{ mt: 1 }} className="avoid-page-break">
                            <DotLegalSection>
                                <DotLegalHeader marginTop={0} marginBottom={0} headerStyle="small">
                                    {translateString("evaluation")}
                                </DotLegalHeader>
                                <EvaluationQuestionnaireContent
                                    evaluationStatus={task?.evaluationStatus}
                                    evaluation={task?.evaluation}
                                    onEvaluationStateChange={() => {}}
                                    onEvaluationChange={() => {}}
                                    useMentionInput
                                    entityId={task.id}
                                    entityType={EntityType.Task}
                                />
                            </DotLegalSection>
                        </Box>
                    )}

                    <Box sx={{ mt: 1 }} className="avoid-page-break">
                        <TaskComments
                            passIsDoneLoading={() => {}}
                            taskId={task.id}
                            taskName={task.name}
                            customId={task.customId}
                            deadline={task.deadline}
                            allDataIsDoneLoading
                            isPdf
                        />
                    </Box>
                </>
            )}
        </Box>
    );
}

export default TaskPdf;
